"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
/**
 * 其它公告页
 */
var fieldtools_1 = __importDefault(require("../../src/modules/commonutil/fieldtools"));
var delayquote_1 = require("../../src/modules/delayquote");
var moment_1 = __importDefault(require("moment"));
//主表配置
loadtabledata();
loadevent();
function loadevent() {
    $(".searchbtn").on('click', kzz_search);
    $("#code").on('keyup', function (event) {
        event = event || window.event;
        if (event.keyCode == 13) {
            kzz_search();
        }
        ;
    });
}
function loadtabledata() {
    //最新公告
    $("#dataview").emdataview({
        dataurl: {
            hostname: "datacenter",
            url: "api/data/v1/get",
            params: {
                reportName: "RPT_BOND_CB_LIST",
                columns: "ALL",
                quoteColumns: "f2~01~CONVERT_STOCK_CODE~CONVERT_STOCK_PRICE,f235~10~SECURITY_CODE~TRANSFER_PRICE,f236~10~SECURITY_CODE~TRANSFER_VALUE,f2~10~SECURITY_CODE~CURRENT_BOND_PRICE,f237~10~SECURITY_CODE~TRANSFER_PREMIUM_RATIO,f239~10~SECURITY_CODE~RESALE_TRIG_PRICE,f240~10~SECURITY_CODE~REDEEM_TRIG_PRICE,f23~01~CONVERT_STOCK_CODE~PBV_RATIO",
                quoteType: delayquote_1.hsaDelay() ? "1" : "0",
                source: "WEB",
                client: "WEB"
            }
        },
        totalpagesfield: 'result.pages',
        datafield: 'result.data',
        urlkeyvalues: {
            pagenumber: "pageNumber",
            pagesize: "pageSize",
            sortname: "sortColumns",
            sortorder: "sortTypes"
        },
        sortname: "PUBLIC_START_DATE",
        rowstyle: function (row, index) {
            var classes = "";
            if (row.PUBLIC_START_DATE && moment_1["default"](row.PUBLIC_START_DATE).format("YYYYMMDD") == moment_1["default"]().format("YYYYMMDD")) {
                classes = "today";
            }
            return {
                classes: classes
            };
        },
        rowattributes: function (row, index) {
            return {
                title: fieldtools_1["default"].isEmpty(row.REMARK) ? "" : row.REMARK
            };
        },
        columns: {
            SECURITY_CODE: {
                formatter: function (value, item, i, field) {
                    if (fieldtools_1["default"].isEmpty(item.LISTING_DATE) || (!fieldtools_1["default"].isEmpty(item.LISTING_DATE) && fieldtools_1["default"].dateformat(item.LISTING_DATE, "YYYYMMDD") > moment_1["default"]().format("YYYYMMDD")) || (!fieldtools_1["default"].isEmpty(item.DELIST_DATE) && fieldtools_1["default"].dateformat(item.DELIST_DATE, "YYYYMMDD") < moment_1["default"]().format("YYYYMMDD")))
                        return value;
                    return "<a href=\"//quote.eastmoney.com/bond/" + (item.TRADE_MARKET == "CNSESH" ? "sh" : "sz") + value + ".html\">" + value + "</a>";
                }
            },
            SECURITY_NAME_ABBR: {
                formatter: function (value, item, i, field) {
                    var _a;
                    //赎回登记日
                    if (((_a = item.RECORD_DATE_SH) === null || _a === void 0 ? void 0 : _a.length) > 5 && fieldtools_1["default"].dateformat(item.RECORD_DATE_SH, "YYYYMMDD") >= moment_1["default"]().add({ days: -10 }).format("YYYYMMDD")) {
                        value = "<span title='" + gettip(item) + "'><span>" + value + "</span><span style='font-weight: bold;color: red;'>!</span></span>";
                    }
                    if (fieldtools_1["default"].isEmpty(item.LISTING_DATE) || (!fieldtools_1["default"].isEmpty(item.LISTING_DATE) && fieldtools_1["default"].dateformat(item.LISTING_DATE, "YYYYMMDD") > moment_1["default"]().format("YYYYMMDD")) || (!fieldtools_1["default"].isEmpty(item.DELIST_DATE) && fieldtools_1["default"].dateformat(item.DELIST_DATE, "YYYYMMDD") < moment_1["default"]().format("YYYYMMDD")))
                        return value;
                    return "<a href=\"//quote.eastmoney.com/bond/" + (item.TRADE_MARKET == "CNSESH" ? "sh" : "sz") + item.SECURITY_CODE + ".html\">" + value + "</a>";
                }
            },
            xg: {
                formatter: function (value, item, i, field) {
                    return "<a class=\"red\" href=\"/kzz/detail/" + item.SECURITY_CODE + ".html\">\u8BE6\u7EC6</a>&nbsp;<a href=\"//guba.eastmoney.com/list," + (item.TRADE_MARKET == "CNSESH" ? "sh" : "sz") + item.SECURITY_CODE + ".html\">\u80A1\u5427</a>";
                }
            },
            PUBLIC_START_DATE: {
                cellstyle: emstyle.nowrap,
                formatter: function (value, item, i, field) {
                    return fieldtools_1["default"].dateformat(value, "YYYY-MM-DD 周W");
                }
            },
            CORRECODE: emfield.string,
            ONLINE_GENERAL_AAU: {
                formatter: { zoom: -1, num: 0, omit: false } //接口是千元，页面是万元
            },
            CONVERT_STOCK_CODE: {
                formatter: function (value, item, i, field) {
                    return "<a href=\"//quote.eastmoney.com/unify/r/" + fieldtools_1["default"].datatoquotecode(value) + "\">" + value + "</a>";
                }
            },
            SECURITY_SHORT_NAME: {
                formatter: function (value, item, i, field) {
                    return "<a href=\"/stockdata/" + item.CONVERT_STOCK_CODE + ".html\">" + fieldtools_1["default"].fmtsname(value) + "</a>";
                }
            },
            CONVERT_STOCK_PRICE: {
                formatter: function (value, item, i, field) {
                    if (value == 0)
                        return '-';
                    return fieldtools_1["default"].fieldfmt(value, { num: 2 });
                }
            },
            TRANSFER_PRICE: emfield.num2,
            TRANSFER_VALUE: emfield.num2,
            CURRENT_BOND_PRICE: {
                formatter: function (value, item, i, field) {
                    if (fieldtools_1["default"].isEmpty(item.CURRENT_BOND_PRICENEW))
                        return fieldtools_1["default"].fieldfmt(value, { num: 2 });
                    else
                        return fieldtools_1["default"].fieldfmt(item.CURRENT_BOND_PRICENEW, { num: 2 });
                }
            },
            TRANSFER_PREMIUM_RATIO: emfield.bfb2_c,
            ACTUAL_ISSUE_SCALE: emfield.num2,
            BOND_START_DATE: {
                formatter: emfield.date_title
            },
            ONLINE_GENERAL_LWR: {
                formatter: { num: 4 }
            },
            LISTING_DATE: {
                formatter: emfield.date_title
            },
            SECURITY_START_DATE: {
                formatter: emfield.date_title
            },
            FIRST_PER_PREPLACING: {
                formatter: { num: 4 }
            }
        }
    });
}
function kzz_search() {
    var s1 = $("#code").val();
    if (s1 == "输入可转债代码" || s1 == "" || isNaN(parseInt(s1)) || s1.length != 6) {
        alert("请输入所有查询可转债的代码！");
        return false;
    }
    else {
        var url = '/kzz/detail/' + s1 + '.html';
        window.open(url);
    }
}
//获取赎回提示
function gettip(data) {
    var tip = data["SECURITY_NAME_ABBR"];
    var shyy = "-";
    switch (data["EXECUTE_REASON_SH"] / 1) {
        case 1:
            shyy = "满足回售条款";
            break;
        case 2:
            shyy = "满足赎回条件";
            break;
        case 3:
            shyy = "满足附加回售条款";
            break;
        case 4:
            shyy = "强制赎回";
            break;
        case 5:
            shyy = "到期赎回";
            break;
    }
    var shll = "";
    switch (data["REDEEM_TYPE"] / 1) {
        case 1:
            shll = "部分赎回";
            break;
        case 2:
            shll = "全部赎回";
            break;
    }
    tip += "&#10;";
    tip += "赎回价格:" + data["EXECUTE_PRICE_SH"];
    tip += "&#10;";
    tip += "最新赎回执行日:" + fieldtools_1["default"].dateformat(data["EXECUTE_START_DATESH"]);
    tip += "&#10;";
    tip += "赎回登记日:" + fieldtools_1["default"].dateformat(data["RECORD_DATE_SH"]);
    tip += "&#10;";
    tip += "最新赎回公告日:" + fieldtools_1["default"].dateformat(data["NOTICE_DATE_SH"]);
    tip += "&#10;";
    tip += "赎回原因:" + shyy;
    tip += "&#10;";
    tip += "赎回类型:" + shll;
    return tip;
}
